/**
 * 病历处方书写相关接口
 */

import request from "@/utils/request";

// 获取待诊已诊患者列表（包含患者基本信息）
export function getPatientVisitList(data) {
    return request({
        url: "/opd-input-order/patient-visit-list",
        method: "post",
        data
    })
}

// 获取已诊和待诊数量
export function getPatientVisitCount(date) {
    return request({
        url: `/opd-input-order/patient-visit-count/${date}`,
        method: "get"
    })
}

// 保存病历和处方信息
export function saveOpdInputOrderMain(data) {
    return request({
        url: "/opd-input-order/save-opd-input-order-main",
        method: "post",
        data
    })
}

// 获取病历信息
export function getPatientGroupSoap(registerid) {
    return request({
        url: `/opd-input-order/page-group-soap/${registerid}`,
        method: "get"
    })
}

// 获取西成药信息
export function getPatientWesternMedicine(registerid) {
    return request({
        url: `/opd-input-order/page-group-western-medicine/${registerid}`,
        method: "get"
    })
}

// 获取中药信息
export function getPatientChineseMedicine(registerid) {
    return request({
        url: `/opd-input-order/page-group-herbal-medicine/${registerid}`,
        method: "get"
    })
}

// 获取输注信息
export function getPatientInjectionMedicine(registerid) {
    return request({
        url: `/opd-input-order/page-group-injection-medicine/${registerid}`,
        method: "get"
    })
}

// 获取检查检验页面内容
export function getInspection(registerid) {
    return request({
        url: `/opd-input-order/page-group-inspection/${registerid}`,
        method: "get",
    })
}

// 获取治疗页面内容
export function getTreatment(registerid) {
    return request({
        url: `/opd-input-order/page-group-treatment/${registerid}`,
        method: "get",
    })
}

// 获取手术页面内容
export function getSurgery(registerid) {
    return request({
        url: `/opd-input-order/page-group-surgery/${registerid}`,
        method: "get",
    })
}

// 快速接诊
export function saveRegisterForQuickVisit(data) {
    return request({
        url: "/opd-input-order/save-register-for-quick-visit",
        method: "post",
        data
    })
}

// 获取辨证列表
export function getDiscriminateList(data) {
    return request({
        url: "/opd-input-order/discriminate-list",
        method: "post",
        data
    })
}

// 获取法治列表
export function getTreatmentList(data) {
    return request({
        url: "/opd-input-order/treatment-list",
        method: "post",
        data
    })
}

// 诊断、辨证、法治判断是否存在
export function isIncludeDiagnosisList(data) {
    return request({
        url: "/opd-input-order/common-diagnosis-list",
        method: "post",
        data
    })
}

// 获取模块设置
export function getModuleSettingList() {
    return request({
        url: "/opd-input-order/module-setting-list",
        method: "get"
    })
}

// 保存模块设置
export function saveModuleSetting(data) {
    return request({
        url: "/opd-input-order/save-module-setting",
        method: "post",
        data
    })
}

// 获取病历设置
export function getMedicalRecordSettingList() {
    return request({
        url: "/opd-input-order/medical-record-setting-list",
        method: "get"
    })
}

// 保存病历设置
export function saveMedicalRecordSetting(data) {
    return request({
        url: "/opd-input-order/save-medical-record-setting",
        method: "post",
        data
    })
}

// 保存煎法
export function saveDecoctionList(data) {
    return request({
        url: "/his-code/save-decoctions",
        method: "post",
        data
    })
}

// 获取病例预览
export function getCasePreview(id) {
    return request({
        url: `/print/soap-preview/${id}`,
        method: "post"
    })
}

// 获取备注
export function getRemark(name) {
    return request({
        url: `/opd-input-order/decoctions/${name}`,
        method: "get"
    })
}

// 保存备注
export function saveRemark(data) {
    return request({
        url: `/opd-input-order/save-decoctions`,
        method: "post",
        data,
    })
}

// 校验历史病例、模板携带的数据，更新连带项
export function checkUpdatePrescriptions(data) {
    return request({
        url: `/opd-input-order/related-opd-input-order-list`,
        method: "post",
        data,
    })
}

// 根据data判断类型 1：诊断 2：辩证 3：治法
function getDiagnoseType(data) {
    let type = 1;
    switch (data) {
        case 'diagnosis':
            type = 1;
            break;
        case 'discriminate':
            type = 2;
            break;
        case 'treatment':
            type = 3;
            break;
    }
    return type;
}

// 获取常用诊断、辩证、治法
export function getUseDiagnosisList(type) {
    return request({
        url: `/opd-input-order/use-${type}-list`,
        method: 'get'
    })
}

// 保存常用诊断、辩证、治法
export function saveUseDiagnosis(type, data) {
    return request({
        url: `/opd-input-order/save-use-diagnosis-list`,
        method: 'post',
        data: {
            ...data,
            diagnosticType: getDiagnoseType(type)
        }
    })
}

// 删除常用诊断、辩证、治法
export function deleteUseDiagnosisById(id) {
    return request({
        url: `/opd-input-order/use-diagnosis-list/${id}`,
        method: 'post'
    })
}

// 根据挂号id获取医生议价和代收金额
export function getVisitPriceByRegisteId(id){
    return request({
        url: `/opd-input-order/visit-price/${id}`,
        method: 'get'
    })
}